export default "__VITE_ASSET__Deok7mXj__"